import React, { PropsWithChildren, ReactElement, useContext } from 'react'
import { Link } from 'react-router'

import PendingApprovalCount from '../../components/widgets/PendingApprovalCount'
import { UserReducer } from '../../reducers/user'
import { getAllParentsForCurrentPath, getMainMenuRegistrationMenu, MenuContext } from '../../utils/menu-utils'
import { connectToReducer } from '../../utils/reducer-utils'
import { RoutePropsLocation } from '../../utils/route-utils'
import { t } from '../../utils/translation-utils'

import './SubmenuLayout.css'

type Reducers = {
  user: UserReducer
}

type Props = PropsWithChildren<{
  location: RoutePropsLocation
}>

function RegistrationLayout(props: Reducers & Props): ReactElement | null {
  const { menu } = useContext(MenuContext)

  if (props.user.user?.uiSettings.sideMenu) {
    return <>{props.children}</>
  }

  const activePath = getAllParentsForCurrentPath(props.location.pathname).map((i) => i.id)

  return (
    <div className="with-submenu">
      <div className="submenu">
        {getMainMenuRegistrationMenu(menu).map((item) => {
          if (item.type === 'item-employee-selector') {
            return null
          }
          return (
            <Link key={item.id} to={item.link} className={activePath.includes(item.id) ? 'active' : ''}>
              {t(item.labelID)}
              {
                item.id === 'registration-menu-approve-tab' && (
                  <PendingApprovalCount />
                ) /* Yes, this is a bit of a hack, but it's the only menu item we have like this, so I'm doing it for now */
              }
            </Link>
          )
        })}
      </div>
      <div className="with-submenu-main">{props.children}</div>
    </div>
  )
}

export default connectToReducer<Reducers, any, Props>((state) => ({ user: state.user }), {})(RegistrationLayout)
